// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Tokens from "@sothebys/sterling/tokens";

var FontFamily = {};

function removeLeadingHashtag(__x) {
  return Js_string.replace("#", "", __x);
}

var alertGreen20_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertGreen20);

var alertGreen60_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertGreen60);

var alertGreen80_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertGreen80);

var alertRed20_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertRed20);

var alertRed60_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertRed60);

var alertRed80_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertRed80);

var alertOrange20_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertOrange20);

var alertOrange60_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertOrange60);

var alertOrange80_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertOrange80);

var alertYellow20_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertYellow20);

var alertYellow60_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertYellow60);

var alertYellow80_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertYellow80);

var alertTurq60_nohashtag = Js_string.replace("#", "", Tokens.Colors.alertTurq60);

var primaryBlack_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryBlack);

var primaryWhite_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryWhite);

var primaryGrey100_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey100);

var primaryGrey90_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey90);

var primaryGrey80_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey80);

var primaryGrey70_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey70);

var primaryGrey60_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey60);

var primaryGrey50_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey50);

var primaryGrey40_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey40);

var primaryGrey30_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey30);

var primaryGrey20_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey20);

var primaryGrey10_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGrey10);

var primaryNavy100_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryNavy100);

var primaryNavy40_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryNavy40);

var primaryBlue80_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryBlue80);

var primaryBlue60_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryBlue60);

var primaryBlue10_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryBlue10);

var primaryGold80_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGold80);

var primaryGold60_nohashtag = Js_string.replace("#", "", Tokens.Colors.primaryGold60);

var Colors = {
  removeLeadingHashtag: removeLeadingHashtag,
  alertGreen20_nohashtag: alertGreen20_nohashtag,
  alertGreen60_nohashtag: alertGreen60_nohashtag,
  alertGreen80_nohashtag: alertGreen80_nohashtag,
  alertRed20_nohashtag: alertRed20_nohashtag,
  alertRed60_nohashtag: alertRed60_nohashtag,
  alertRed80_nohashtag: alertRed80_nohashtag,
  alertOrange20_nohashtag: alertOrange20_nohashtag,
  alertOrange60_nohashtag: alertOrange60_nohashtag,
  alertOrange80_nohashtag: alertOrange80_nohashtag,
  alertYellow20_nohashtag: alertYellow20_nohashtag,
  alertYellow60_nohashtag: alertYellow60_nohashtag,
  alertYellow80_nohashtag: alertYellow80_nohashtag,
  alertTurq60_nohashtag: alertTurq60_nohashtag,
  primaryBlack_nohashtag: primaryBlack_nohashtag,
  primaryWhite_nohashtag: primaryWhite_nohashtag,
  primaryGrey100_nohashtag: primaryGrey100_nohashtag,
  primaryGrey90_nohashtag: primaryGrey90_nohashtag,
  primaryGrey80_nohashtag: primaryGrey80_nohashtag,
  primaryGrey70_nohashtag: primaryGrey70_nohashtag,
  primaryGrey60_nohashtag: primaryGrey60_nohashtag,
  primaryGrey50_nohashtag: primaryGrey50_nohashtag,
  primaryGrey40_nohashtag: primaryGrey40_nohashtag,
  primaryGrey30_nohashtag: primaryGrey30_nohashtag,
  primaryGrey20_nohashtag: primaryGrey20_nohashtag,
  primaryGrey10_nohashtag: primaryGrey10_nohashtag,
  primaryNavy100_nohashtag: primaryNavy100_nohashtag,
  primaryNavy40_nohashtag: primaryNavy40_nohashtag,
  primaryBlue80_nohashtag: primaryBlue80_nohashtag,
  primaryBlue60_nohashtag: primaryBlue60_nohashtag,
  primaryBlue10_nohashtag: primaryBlue10_nohashtag,
  primaryGold80_nohashtag: primaryGold80_nohashtag,
  primaryGold60_nohashtag: primaryGold60_nohashtag
};

var Typography = {};

export {
  FontFamily ,
  Colors ,
  Typography ,
}
/* alertGreen20_nohashtag Not a pure module */
